
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'send-email': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path fill-rule="evenodd" clip-rule="evenodd" d="M9.71835 7.89111L1.16608 0H20.0753L11.523 7.89111C11.0178 8.35911 10.2243 8.35911 9.71835 7.89111ZM0 12.4395V0.975586L5.99784 6.50977L0 12.4395ZM21.2414 0.975586L15.7132 6.07617C16.0326 6.03117 16.3574 6 16.6897 6C18.4406 6 20.0329 6.65677 21.2414 7.72852V0.975586ZM11.3793 12.75C11.3793 9.8505 13.7568 7.5 16.6897 7.5C19.6225 7.5 22 9.8505 22 12.75C22 15.6495 19.6225 18 16.6897 18C13.7568 18 11.3793 15.6495 11.3793 12.75ZM7.10614 7.53369L1.07274 13.5H9.90652C9.87845 13.2533 9.86207 13.0035 9.86207 12.75C9.86207 11.6655 10.1269 10.6451 10.5866 9.73682C9.90082 9.72857 9.21748 9.48032 8.68265 8.98682L7.10614 7.53369ZM19.7241 12.75L16.6897 9.75V12H14.4138C13.995 12 13.6552 12.3352 13.6552 12.75C13.6552 13.1648 13.995 13.5 14.4138 13.5H16.6897V15.75L19.7241 12.75Z" fill="#93A0AE"/>'
  }
})
